module.exports = __webpack_public_path__ + "media/Video 2b.c34c5f9d.mp4";